import React, { useContext } from 'react';
import UserPrefsContext from '../../../context/UserPrefs/UserPrefsContext';

import { FormattedMessage, useIntl } from 'react-intl';

const InputElectricityRate = () => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);

  const label = intl.formatMessage({
    id: 'ev.electricityRate',
    defaultMessage: 'Home electricity rate ($/kWh)',
  });

  return (
    <>
      <label>{label}</label>

      <div className="currency-wrap">
        <span className="currency-code">$</span>
        <input
          value={Math.round(userPrefs.get('electricityRate')) / 100}
          className="text-currency form-control form-control-input"
          type="number"
          placeholder="0.01"
          step={0.01}
          min={0}
          onChange={(e) => {
            if (e.target.value < 10) {
              const decimalRegex = /\.(\d{5,})$/;
              if (!decimalRegex.test(e.target.value.toString())) {
                userPrefs.set({
                  electricityRate: Math.round(e.target.value * 100),
                });
              }
            }
          }}
          lang="en-150"
        />
        <span className="unit-code">/kWh</span>
      </div>

      <p>
        <FormattedMessage
          id="ev.electricityRateCalc"
          defaultMessage="Electricity rate default value is SMUD's average residential rate with the EV discount in 2025. Users can adjust to explore various pricing options."
          description="Electricicty Rate Text"
        />
      </p>
    </>
  );
};

export default InputElectricityRate;
